import { React, Input, Button, Heading, Row, Col, Text, Shortcut, Subtitle } from "mondrian-react";
import { useEffect } from "react";
import { ReCaptcha } from "react-recaptcha-v3";
import { reportGA4, reportPageViewGA4 } from "utils/pushDataLayer";
import { logger } from "utils/logger";
import useIsTotem from 'hooks/useIsTotem';

import "./styles.scss";

const PhoneStep = ({
  propsLineNumber,
  propsButtonSubmit,
  recaptchaRef,
  verifyCallback,
}) => {
  useEffect(() => {
    reportPageViewGA4({ customTitle: 'validacao_do_numero' });
  }, [])

  const urlQuery = window.location.search;
  const urlParams = new URLSearchParams(urlQuery);
  const isPJ = urlParams.get('utm_campaign') === 'movel_site_pj_fatura_facil';


  useEffect(() => {
    if (isPJ) {
      reportGA4({
        event: "callback",
        customTitle: 'pageview',
        customCallback: 'sucesso'
      })
    }
  }, [])


  const isTotem = useIsTotem();

  return (
    <>
      <Row>
        {isPJ && (
          <>
            <Col xs={12} lg={8} className="mdn-Offset-lg-1 mdn-u-flex mdn-u-alignItems-xs-center">
              <Subtitle xs className="mdn-u-marginBottom--xs">
                Para obter a conta desejada informe um número de linha associada a ela.<br />
                Caso tenha mais de uma conta, é necessário informar cada linha individualmente.
              </Subtitle>
            </Col>
          </>
        )}
        <Col id="autoScrollIdentifier" xs={12} lg={10} className="mdn-Offset-lg-1">
          <Heading xs className="mcm-StepTitle">
            {!isPJ ? 'Informe o número do titular da linha' : 'Informe uma linha associada a sua conta'}
          </Heading>
        </Col>
        <Col xs={9} lg={3} className="mdn-Offset-lg-1">
          <Input
            phone
            autoFocus={!isPJ}
            {...propsLineNumber}
            className="msisdn"
            errorMessage="Insira um celular válido!"
            aria-label="Insira o DDD junto com o número do telefone"
          >
            DDD + Celular
          </Input>
          <ReCaptcha
            ref={recaptchaRef}
            sitekey={process.env.REACT_APP_RECAPTCHA_CLIENT}
            verifyCallback={verifyCallback}
          />
        </Col>
        <Col xs={12} lg={2} className="mdn-u-flex mdn-u-justifyContent-lg-end mdn-u-alignItems-xs-center">
          <Button {...propsButtonSubmit}>Continuar</Button>
        </Col>
      </Row>
      {!isTotem &&
        <Row className="payment-section">
          <Col xs={12}>
            <h2 className="mdn-Heading mdn-Heading--sm heading">
              Precisa de ajuda para realizar o pagamento?
            </h2>
            <Text className="mdn-Text mdn-Text--body subtitle">
              Facilite o pagamento de suas dívidas e regularize suas pendências com a Claro.
            </Text>
            <div className="">
              <Shortcut
                onClick={() => {
                  logger({ name: "RedirectClaroNegocie" });
                  reportGA4({ customTitle: 'validacao_do_numero:claro_negocie' })
                }}
                href="https://claronegocie.com.br/login"
                className="card1"
                icon={"mdn-Shortcut-icon mdn-Icon-claro mdn-Icon--md"}
                title="Ir para Claro negocie"
                target="_blank"
              >
                Claro negocie
              </Shortcut>
              <Shortcut
                onClick={() => {
                  logger({ name: "RedirectClaroEmpresas" });
                  reportGA4({ customTitle: 'validacao_do_numero:claro_empresas' })
                }}
                href="https://minhaclaroempresas.claro.com.br/#AutenticacaoUsuario"
                className="card1"
                icon={"mdn-Shortcut-icon mdn-Icon-empresa mdn-Icon--md"}
                inverse
                title="Ir para Claro empresas"
                target="_blank"
              >
                Claro empresas
              </Shortcut>
            </div>
          </Col>
        </Row>
      }
      {!isTotem && !isPJ &&
        <Row className="facilities-shortcuts">
          <Col xs={12}>
            <h2 className="mdn-Heading mdn-Heading--sm heading">
              Facilidades no Minha Claro móvel
            </h2>
            <div className="">
              <Shortcut
                onClick={() => {
                  logger({ name: "RedirectFaturaDetalhada" });
                  reportGA4({ customTitle: 'detalhes_de_fatura:minha_claro_movel' })
                }}
                href="https://minhaclaro.claro.com.br/?redirect-feature=FaturasMinhasFaturas"
                className="card1"
                icon={"mdn-Shortcut-icon mdn-Icon-dinheiro-cifrao-caneta mdn-Icon--md"}
                title="Ir para Fatura detalhada"
                target="_blank"
              >
                Fatura detalhada
              </Shortcut>
              <Shortcut
                onClick={() => {
                  logger({ name: "RedirectMudeSeuPlano" });
                  reportGA4({ customTitle: 'mude_seu_plano:loja' })
                }}
                href="https://minhaclaro.claro.com.br/?redirect-feature=OutrosPlanos"
                className="card1"
                icon={"mdn-Shortcut-icon mdn-Icon-setas-sentido-oposto mdn-Icon--md"}
                inverse
                title="Ir para Mude seu plano"
                target="_blank"
              >
                Mude seu plano
              </Shortcut>
              <Shortcut
                onClick={() => {
                  logger({ name: "RedirectLoja" });
                  reportGA4({ customTitle: 'loja:minha_claro_movel' })
                }}
                href="https://minhaclaro.claro.com.br/?redirect-feature=Loja"
                className="card1"
                icon={"mdn-Shortcut-icon mdn-Icon-sacola-cifrao mdn-Icon--md"}
                inverse
                title="Ir para Loja"
                target="_blank"
              >
                Loja
              </Shortcut>
              <Shortcut
                onClick={() => {
                  logger({ name: "RedirectSuporteTecnico" });
                  reportGA4({ customTitle: 'suporte_tecnico:minha_claro_movel' })
                }}
                href="https://minhaclaro.claro.com.br/?redirect-feature=AtendimentoGuiaSolucoes"
                className="card1"
                icon={"mdn-Shortcut-icon mdn-Icon-chave-combinada-fenda mdn-Icon--md"}
                inverse
                title="Ir para Suporte técnico"
                target="_blank"
              >
                Suporte técnico
              </Shortcut>
              <Shortcut
                onClick={() => {
                  logger({ name: "RedirectClaroClube" });
                  reportGA4({ customTitle: 'claro_clube:minha_claro_movel' })
                }}
                href="https://minhaclaro.claro.com.br/?redirect-feature=ClaroClubeClienteCadastrado"
                className="card1"
                icon={"mdn-Shortcut-icon mdn-Icon-claro mdn-Icon--md"}
                inverse
                title="Ir para Claro clube"
                target="_blank"
              >
                Claro clube
              </Shortcut>
            </div>
          </Col>
        </Row>
      }
   
      <Row className="other-access-shortcuts">
        <Col xs={12}>
          <h2 className="mdn-Heading mdn-Heading--sm heading">
            Outros acessos
          </h2>
          <div className="">
            <Shortcut
              onClick={() => {
                logger({ name: "RedirectFaturaFacilProdutosFixos" });
                reportGA4({ customTitle: 'fatura_facil:produtos_fixos' })
              }}
              href="https://www.claro.com.br/minha/publico/fatura-facil-pme"
              className="card1"
              icon={"mdn-Shortcut-icon mdn-Icon-empresa mdn-Icon--md"}
              inverse
              title="Ir para Fatura fácil produtos fixos"
              target="_blank"
            >
              Fatura fácil produtos fixos
            </Shortcut>
          </div>
        </Col>
      </Row>
    </>
  );
};
export default PhoneStep;
